import React, { PureComponent } from "react";
import Typist from "react-typist";

class HeaderGameName extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      typing: true
    };
  }

  get textStyle() {
    const { team_color } = this.props;

    return {
      color: team_color,
      fontSize: "20px"
    };
  }

  get typistStyle() {
    return {
      show: true,
      blink: true,
      element: "|",
      hideWhenDone: false,
      hideWhenDoneDelay: 300
    };
  }

  onTypingDone = () => {
    this.setState({
      typing: false
    });
  };

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return roundInUrl !== null && roundInUrl !== currentRound
      ? roundInUrl
      : currentRound;
  }

  get gameName() {
    const { rounds } = this.props;
    const round = rounds.find(i => i.number === this.activeRound);

    return round ? round.game_name : "";
  }

  get renderText() {
    return <b style={this.textStyle}>{this.gameName}</b>;
  }

  render() {
    const { typing } = this.state;

    if (this.gameName === "") return null;

    return typing === true ? (
      <Typist
        cursor={this.typistStyle}
        avgTypingDelay={150}
        className="inline-block"
        onTypingDone={this.onTypingDone}
      >
        {this.renderText}
      </Typist>
    ) : (
      this.renderText
    );
  }
}

export default HeaderGameName;



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/header-game-name.js